import {
  useReactTable,
  getCoreRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  getFilteredRowModel,
} from "@tanstack/react-table";
import React from "react";

import PropTypes from "prop-types";

export default function TableVenta({ data, columns }) {
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
  });
  return (
    <>
      <table className="table fs-9 mb-0 border-top border-translucent">
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <React.Fragment key={header.id}>
                  {header.column.columnDef.header}
                </React.Fragment>
              ))}
            </tr>
          ))}
        </thead>
        <tbody className="list" id="order-table-body">
          {table.getRowModel().rows.map((row) => (
            <tr
              key={row.id}
              className="hover-actions-trigger btn-reveal-trigger position-static"
            >
              {row.getVisibleCells().map((cell) => (
                <React.Fragment key={cell.id}>
                  {cell.column.columnDef.cell ? cell.column.columnDef.cell(cell.getContext()) : cell.getValue()}
                </React.Fragment>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

TableVenta.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
};